<template>
  <div>
    <div class="login-container">
      <img :src="$env.imgUrl + 'PBLLOGO.png'" alt="" class="regist-title-rightImg" @click="backtoHomeClicked" />
      <div class="main safe-area">
        <div class="card">
          <div class="productName">{{ productName }}</div>
          <div class="lr">
            <div class="online-pay">
              <div style="flex: 1;">
                <div class="productPrice">
                  <span>订单总价：</span>
                  <div>
                    ¥ {{ productPrice }}
                  </div>
                </div>
                <div class="expand-section">
                  <div class="expand-title">个人信息：</div>
                  <div class="table">
                    <div class="th">
                      <div class="tit">姓名</div>
                      <div class="td">{{ userInfo.userName }}</div>
                    </div>
                    <div class="th">
                      <div class="tit">性别</div>
                      <div class="td">{{ userInfo.sex === '1' ? '女' : '男' }}</div>
                    </div>
                    <div class="th">
                      <div class="tit">手机号</div>
                      <div class="td">{{ userInfo.phone }}</div>
                    </div>
                    <div class="th">
                      <div class="tit">邮箱</div>
                      <div class="td">{{ userInfo.email }}</div>
                    </div>
                    <div class="th">
                      <div class="tit">报名费</div>
                      <div class="td">¥{{ productPrice }}</div>
                    </div>
                    <div class="th">
                      <div class="tit">状态</div>
                      <div class="td">
                        <el-tag :type="userInfo.paydStatus ? 'success' : 'danger'" size="mini" effect="dark">{{
                          userInfo.paydStatus ? '已支付' : '未支付' }}</el-tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pay-box" v-if="!userInfo.paydStatus">
              <template v-if="qrImgSrc">
                <div class="scan">请使用微信扫码支付</div>
                <img :src="qrImgSrc" class="qrCode" alt="">
                <img class="wxzf" :src="$env.imgUrl + 'wxzf.png'" alt="">
              </template>
              <div v-else class="qrCodeLoading">
                <i class="el-icon-loading"></i>
                <div>正在生成订单</div>
              </div>
            </div>
          </div>
          <div class="btns" v-if="!userInfo.paydStatus">
            <div class="btn2" @click="getPayResult">我已完成支付</div>
          </div>
          <div class="pay-tip" v-if="!userInfo.paydStatus">请使用微信扫码支付</div>
        </div>
        <div class="card tips">
          <div class="title">报名须知</div>
          <div class="entitle">Registration Notice</div>
          一、注册报名时间:2026年8月1日-9月30日<br /><br />
          二、报名费用:2680元/人<br /><br />
          三、费用说明:队伍费用按照整体的队伍人数计算，添加战队成员后，费用自动生成，由带队教师缴费。<br /><br />
          四、活动时间:2026年11月初<br /><br />
          五、活动地点:深圳<br /><br />
          六、项目提报时间:即日起至2026年9月30日截止<br />
          注:提报展演项目需要接受组委会审核，每个学校可遴选多支队伍参赛，自行选择主题。<br /><br />
          七、资料上传说明:即日起至2026年10月30日截止<br />
          注:四项展演作品的材料需按照要求由指导教师上传至教师端口，由组委会统一审核。<br /><br />
          八、退费说明:<br />
          如因校方原因无故缺席展演，注册费一律不退。<br />
          如因组委会原因未能展演成功，按实际已消耗费用扣除相应费用后退费。
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      schoolLevel: '',
      activityType: 3,
      active: 1,
      dict_grade: this.$curUtils.getGradeData(),
      students: [],
      havePayed: false,

      qrImgSrc: '',
      orderId: '',
      payForm: {
        id: '',
        payImageUrl: '',
        payNote: ''
      },
      theme: '',
      entheme: '',
      val: '',
      enval: '',
      schoolName: '',
      address: '',
      productPrice: '',
      productName: '',
      pblTeamId: '',
      userInfo: {}
    }
  },
  created() {
    this.code = this.$route.query.code
    this.getInitInfo()
  },
  methods: {
    backtoHomeClicked() {
      this.$router.push('/')
    },
    getInitInfo() {
      this.$http.get('common/pblTeam/getTeamUserPay', { params: { code: this.code } }).then(res => {
        if (res.code === 200) {
          this.pblTeamId = res.data.teamId
          this.userInfo = res.data
          this.id = res.data.id
          this.getQRCode()
        }
      })
    },

    createOrder(data) {
      const paramsData = {
        num: 1,
        orderSource: 2,
        payType: '微信',
        paymentAmount: data.tbProductDetails[0].price,
        productId: data.id,
        tbProductDetailId: data.tbProductDetails[0].id,
        pblTeamId: this.pblTeamId,
        pblTeamUserId: this.id
      }
      this.$http.post('common/order/creatTbProductOrder', paramsData).then(res => {
        if (res.data) {
          this.qrImgSrc = res.data.qcPicCode
          this.orderId = res.data.orderId
          this.productPrice = res.data.productPrice
          this.productName = res.data.productName
        }
      })
    },
    getPayResult() {
      this.$http.post('common/order/getTbProductOrderIsFinish', { id: this.orderId }).then(res => {
        if (res.code === 200) {
          this.$message.success('支付成功')
          this.handleToCancelPay()
        } else {
          this.$confirm('系统检测到订单未支付成功', '提示', {
            confirmButtonText: '重新支付',
            cancelButtonText: '取消支付',
            type: 'warning'
          }).then(() => {

          }).catch(() => {
            this.handleToCancelPay()
          })
        }
      })
    },
    handleToCancelPay() {
      this.$router.push('/')
    },
    getQRCode() {
      this.$http.get('common/product/getTbProductByFlag', { params: { flag: 'PBL_TEAM' } }).then(res => {
        if (res.code === 200) {
          this.productPrice = res.data.tbProductDetails[0].price
          this.productName = res.data.productName
          if (this.userInfo.paydStatus) {
            this.havePayed = true
            return
          }
          this.createOrder(res.data)
        }
      })
    },
    sexFormat(data) {
      return Number(data.sex) === 1 ? '女' : Number(data.sex) === 2 ? '男' : ''
    },
    gradeFormat(data) {
      return this.dict_grade.find(item => item.dictCode === data.grade).dictLabel
    }

  }
}
</script>

<style lang="less" scoped>
.pay-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  background-color: rgba(201, 39, 58, .1);

  .pay-tab-item {
    width: 200px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-family: systm;
    font-size: 14px;
    color: #999;
    border-bottom: 3px solid transparent;
    cursor: pointer;

    &.active {
      border-bottom-color: #b81c25;
      color: #b81c25;
      font-family: systh;
    }
  }
}

.online-pay {
  width: 90%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.pay-box {
  border: 1px solid #F4F4F5;
  background-color: #fff;
  padding: 20px;
  text-align: center;
  width: 220px;
  margin-left: 20px;

  .wxzf {
    width: 120px;
    height: auto;
  }
}

.pay-tip {
  color: #999;
  font-size: 12px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.el-button--primary {
  background-color: #b81c25;
  border: 1px solid #b81c25;
  margin-bottom: 0px;

  &:hover {
    background-color: #b81c25;
    border-color: #b81c25;
  }

  span {
    font-family: Microsoft YaHei UI;
    color: #fff;
    font-size: 20px;
    letter-spacing: 1px;
  }
}

.el-button--text {
  color: #b81c25;
  font-size: 14px;
  text-decoration: underline;
}

.top-left-backhome {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 20px;
  top: 20px;
}

.top-left-backTitle {
  // margin-left: 0px;
  color: #b81c25;
  border: 0;
  background-color: white;
}

.login-container {
  margin: 0 auto;
  background: url(https://cdn.spbcn.org/spbcnWeb/pbl/reg-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 80px;
    height: calc(100vh - 100px);
    overflow-y: auto;
  }
}

.regist-title-rightImg {
  width: auto;
  height: 50px;
  position: fixed;
  top: 20px;
  left: 40px;
}

.footer {
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  font-family: regular;
  font-size: 16px;

  span {
    margin: 0 40px;
  }
}

.el-button--primary {
  background-color: #b81c25;
  border: 1px solid #b81c25;
  margin: 0 auto 10px;
  display: block;

  &:hover {
    background-color: #b81c25;
    border-color: #b81c25;
  }

  span {
    font-family: Microsoft YaHei UI;
    color: #fff;
    font-size: 20px;
    letter-spacing: 1px;
  }
}

.tips {
  color: #b81c25;
  font-size: 12px;
  font-family: systm;
  margin-top: 20px;
}

.scan {
  color: #000;
  font-size: 14px;
  text-align: center;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.label {
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666;
}

.value {
  flex: 1;
  margin-left: 30px;
  font-size: 14px;
  color: #000;
}

.qrCode {
  width: 200px;
  height: 200px;
  display: block;
  margin: 10px auto;
}

.qrCodeLoading {
  color: #b81c25;
  font-size: 16px;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10px auto;

  i {
    font-size: 20px;
  }
}

.btns {
  margin-top: 20px;
  text-align: center;

  .btn1 {
    border-color: #000;
    color: #000;
    border-radius: 40px;
    margin-right: 20px;
    width: 140px;
  }

  .btn2 {
    background-color: #b81c25;
    border-bottom: #b81c25;
    border-radius: 40px;
    color: #fff;
    margin-right: 20px;
    width: 140px;
    font-size: 12px;
    text-align: center;
    line-height: 32px;
    height: 32px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.mt-40 {
  margin: 40px auto 0;
  width: 600px;
}

.teamNum {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  margin: 20px 0;

  .num {
    color: #b81c25;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}

.operate {
  display: flex;
  align-items: center;

  i {
    font-size: 20px;
    color: #b81c25;
    margin-left: 20px;
    cursor: pointer;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px dashed #999;
}

.card {
  background-color: #FFF;
  border-radius: 20px;
  padding: 20px;

  .title {
    color: #000;
    font-family: systh;
    font-size: 16px;
  }

  .entitle {
    color: #000;
    font-family: systh;
    font-size: 10px;
    margin-bottom: 20px;
  }
}

.mt-30 {
  margin-top: 30px;
}

.user-card {
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border-radius: 14px;

  .user-card-title {
    background-color: #C9273A;
    height: 40px;
    color: #fff;
    font-family: systh;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px 14px 0 0;
    margin-bottom: 10px;
    position: relative;

    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }

    .remove {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
    }
  }
}

.pr-20 {
  padding-right: 20px;
}

.add-btn {
  color: #fff;
  background-color: #C9273A;
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-family: systh;
  font-size: 12px;
  cursor: pointer;
  border-radius: 32px;
  margin-top: 20px;
}

.submit {
  margin-top: 20px;
  width: 140px;
}

.item {
  margin-bottom: 14px;
  display: flex;
  align-items: center;

  .key {
    color: #606266;
    font-family: systm;
    font-size: 12px;
    border-radius: 20px;
    width: 20px;
    height: 68px;
    border: 1px solid #DCDFE6;
    text-align: center;
    padding: 10px 0;
  }

  .val {
    width: 400px;
    height: 88px;
    background-position: center;
    background-size: cover;
    margin-left: 20px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;

    .cn {
      font-size: 16px;
      font-family: systh;
    }

    .en {
      font-size: 12px;
      font-family: systh;
    }
  }

  .val2 {
    background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/bg111.png);
  }

  .val1 {
    background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/bg222.png);
  }
}

.item2 {
  border: 1px solid #DCDFE6;
  height: 32px;
  line-height: 32px;
  width: 100%;
  border-radius: 32px;
  color: #606266;
  display: flex;
  font-size: 14px;
  font-family: systm;
  margin-bottom: 30px;

  .key {
    width: 60px;
    padding: 0 10px;
    border-right: 1px solid #DCDFE6;
    margin-right: 10px;
  }

  .val {
    color: #000;
  }
}

.info-check {
  width: 100px;
  height: 100px;
  object-fit: contain;
  display: block;
  margin: 40px auto;
  background-color: #b81c25;
  border-radius: 100px;
  padding: 20px;
}

.tip {
  color: #b81c25;
  text-align: center;
  margin-top: 40px;
  font-size: 14px;
  font-family: systh;
}

.entip {
  color: #b81c25;
  text-align: center;
  margin: 10px auto;
  font-size: 10px;
  font-family: systh;
  width: 60%;
}

.page-step {
  top: 20px;
}

.img-detail {
  max-width: 300px;
}

::v-deep .el-input__inner {
  border-radius: 40px;
}

::v-deep .el-textarea__inner {
  border-radius: 14px;
}

.productPrice {
  font-family: systh;
  font-size: 18px;
  color: #b81c25;
  margin-bottom: 20px;

  span {
    color: #606266;
    font-family: systm;
    font-size: 14px;
  }
}

.productName {
  font-family: systh;
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
  text-align: center;
  padding-top: 10px;
}

.expand-section {
  width: 100%;

  .expand-title {
    color: #606266;
    font-family: systm;
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}

.table {
  width: 100%;
  border: 1px solid #EBEEF5;
  border-right: none;
  border-bottom: none;
  display: flex;

  .th {
    flex: 1;
    width: 100%;

    .tit {
      flex: 1;
      text-align: center;
      color: #606266;
      font-weight: bold;
      font-size: 12px;
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      height: 40px;
      line-height: 40px;
    }

    .td {
      flex: 1;
      text-align: center;
      color: #000;
      font-weight: bold;
      font-size: 12px;
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
      height: 40px;
      line-height: 40px;
    }
  }
}
.lr{
  display: flex;
  align-items: flex-start;
}
</style>
